import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "./main.css";
import { baseStyleProps as $9LQqs$baseStyleProps, passthroughStyle as $9LQqs$passthroughStyle, dimensionValue as $9LQqs$dimensionValue, useStyleProps as $9LQqs$useStyleProps, useDOMRef as $9LQqs$useDOMRef, useBreakpoint as $9LQqs$useBreakpoint, responsiveDimensionValue as $9LQqs$responsiveDimensionValue, classNames as $9LQqs$classNames } from "@react-spectrum/utils";
import { filterDOMProps as $9LQqs$filterDOMProps } from "@react-aria/utils";
import $9LQqs$react, { forwardRef as $9LQqs$forwardRef } from "react";
import { useIsSSR as $9LQqs$useIsSSR } from "@react-aria/ssr";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $994c48bfb00b620b$exports = {};
$parcel$export($994c48bfb00b620b$exports, "repeat", function () {
  return $994c48bfb00b620b$export$76d90c956114f2c2;
});
$parcel$export($994c48bfb00b620b$exports, "minmax", function () {
  return $994c48bfb00b620b$export$9c1b655deaca4988;
});
$parcel$export($994c48bfb00b620b$exports, "fitContent", function () {
  return $994c48bfb00b620b$export$2f0b47b0911ce698;
});
$parcel$export($994c48bfb00b620b$exports, "Grid", function () {
  return $994c48bfb00b620b$export$ef2184bd89960b14;
});

var $994c48bfb00b620b$var$gridStyleProps = _objectSpread(_objectSpread({}, $9LQqs$baseStyleProps), {}, {
  autoFlow: ['gridAutoFlow', $9LQqs$passthroughStyle],
  autoColumns: ['gridAutoColumns', $994c48bfb00b620b$var$gridDimensionValue],
  autoRows: ['gridAutoRows', $994c48bfb00b620b$var$gridDimensionValue],
  areas: ['gridTemplateAreas', $994c48bfb00b620b$var$gridTemplateAreasValue],
  columns: ['gridTemplateColumns', $994c48bfb00b620b$var$gridTemplateValue],
  rows: ['gridTemplateRows', $994c48bfb00b620b$var$gridTemplateValue],
  gap: ['gap', $9LQqs$dimensionValue],
  rowGap: ['rowGap', $9LQqs$dimensionValue],
  columnGap: ['columnGap', $9LQqs$dimensionValue],
  justifyItems: ['justifyItems', $9LQqs$passthroughStyle],
  justifyContent: ['justifyContent', $9LQqs$passthroughStyle],
  alignItems: ['alignItems', $9LQqs$passthroughStyle],
  alignContent: ['alignContent', $9LQqs$passthroughStyle]
});

function $994c48bfb00b620b$var$Grid(props, ref) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _$9LQqs$useStyleProps = $9LQqs$useStyleProps(otherProps, $994c48bfb00b620b$var$gridStyleProps),
      styleProps = _$9LQqs$useStyleProps.styleProps;

  styleProps.style.display = 'grid'; // inline-grid?

  var domRef = $9LQqs$useDOMRef(ref);
  return /*#__PURE__*/$9LQqs$react.createElement("div", _objectSpread(_objectSpread(_objectSpread({}, $9LQqs$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), children);
}

function $994c48bfb00b620b$export$76d90c956114f2c2(count, $994c48bfb00b620b$export$76d90c956114f2c2) {
  return "repeat(".concat(count, ", ").concat($994c48bfb00b620b$var$gridTemplateValue($994c48bfb00b620b$export$76d90c956114f2c2), ")");
}

function $994c48bfb00b620b$export$9c1b655deaca4988(min, max) {
  return "minmax(".concat($994c48bfb00b620b$var$gridDimensionValue(min), ", ").concat($994c48bfb00b620b$var$gridDimensionValue(max), ")");
}

function $994c48bfb00b620b$export$2f0b47b0911ce698(dimension) {
  return "fit-content(".concat($994c48bfb00b620b$var$gridDimensionValue(dimension), ")");
}

function $994c48bfb00b620b$var$gridTemplateAreasValue(value) {
  return value.map(function (v) {
    return "\"".concat(v, "\"");
  }).join('\n');
}

function $994c48bfb00b620b$var$gridDimensionValue(value) {
  if (/^max-content|min-content|minmax|auto|fit-content|repeat|subgrid/.test(value)) return value;
  return $9LQqs$dimensionValue(value);
}

function $994c48bfb00b620b$var$gridTemplateValue(value) {
  if (Array.isArray(value)) return value.map($994c48bfb00b620b$var$gridDimensionValue).join(' ');
  return $994c48bfb00b620b$var$gridDimensionValue(value);
}
/**
 * A layout container using CSS grid. Supports Spectrum dimensions as values to
 * ensure consistent and adaptive sizing and spacing.
 */


var $994c48bfb00b620b$export$ef2184bd89960b14 = /*#__PURE__*/$9LQqs$forwardRef($994c48bfb00b620b$var$Grid);
var $884c64d19340d345$exports = {};
$parcel$export($884c64d19340d345$exports, "Flex", function () {
  return $884c64d19340d345$export$f51f4c4ede09e011;
});
var $01dd1839b5376a46$exports = {};
$parcel$export($01dd1839b5376a46$exports, "flex-container", function () {
  return $01dd1839b5376a46$export$69d7a39fa31a000b;
}, function (v) {
  return $01dd1839b5376a46$export$69d7a39fa31a000b = v;
});
$parcel$export($01dd1839b5376a46$exports, "flex", function () {
  return $01dd1839b5376a46$export$97691fbb80847c19;
}, function (v) {
  return $01dd1839b5376a46$export$97691fbb80847c19 = v;
});
$parcel$export($01dd1839b5376a46$exports, "flex-gap", function () {
  return $01dd1839b5376a46$export$31a9da8b58047a44;
}, function (v) {
  return $01dd1839b5376a46$export$31a9da8b58047a44 = v;
});
var $01dd1839b5376a46$export$69d7a39fa31a000b;
var $01dd1839b5376a46$export$97691fbb80847c19;
var $01dd1839b5376a46$export$31a9da8b58047a44;
$01dd1839b5376a46$export$69d7a39fa31a000b = "flex-container_e15493";
$01dd1839b5376a46$export$97691fbb80847c19 = "flex_e15493";
$01dd1839b5376a46$export$31a9da8b58047a44 = "flex-gap_e15493";
var $884c64d19340d345$var$flexStyleProps = {
  direction: ['flexDirection', $9LQqs$passthroughStyle],
  wrap: ['flexWrap', $884c64d19340d345$var$flexWrapValue],
  justifyContent: ['justifyContent', $884c64d19340d345$var$flexAlignValue],
  alignItems: ['alignItems', $884c64d19340d345$var$flexAlignValue],
  alignContent: ['alignContent', $884c64d19340d345$var$flexAlignValue]
};

function $884c64d19340d345$var$Flex(props, ref) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var breakpointProvider = $9LQqs$useBreakpoint();
  var matchedBreakpoints = (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || ['base'];

  var _$9LQqs$useStyleProps2 = $9LQqs$useStyleProps(otherProps),
      styleProps = _$9LQqs$useStyleProps2.styleProps;

  var _$9LQqs$useStyleProps3 = $9LQqs$useStyleProps(otherProps, $884c64d19340d345$var$flexStyleProps),
      flexStyle = _$9LQqs$useStyleProps3.styleProps;

  var domRef = $9LQqs$useDOMRef(ref);
  var isSSR = $9LQqs$useIsSSR(); // If a gap property is specified, and there is no native support or we're in SSR, use a shim.
  // Two divs are required for this: the outer one contains most style properties, and the inner
  // one is the flex container. Each item inside the flex container gets a margin around it based
  // on the gap, and the flex container has a negative margin to counteract this. The outer container
  // is necessary to allow nesting of flex containers with gaps, so that the inner CSS variable doesn't
  // override the outer one.

  if ((props.gap || props.rowGap || props.columnGap) && (isSSR || !$884c64d19340d345$var$isFlexGapSupported())) {
    var _style = _objectSpread(_objectSpread({}, flexStyle.style), {}, {
      '--column-gap': props.columnGap != null ? $9LQqs$responsiveDimensionValue(props.columnGap, matchedBreakpoints) : undefined,
      '--row-gap': props.rowGap != null ? $9LQqs$responsiveDimensionValue(props.rowGap, matchedBreakpoints) : undefined,
      '--gap': props.gap != null ? $9LQqs$responsiveDimensionValue(props.gap, matchedBreakpoints) : undefined
    });

    return /*#__PURE__*/$9LQqs$react.createElement("div", _objectSpread(_objectSpread(_objectSpread({}, $9LQqs$filterDOMProps(otherProps)), styleProps), {}, {
      className: $9LQqs$classNames( /*@__PURE__*/$parcel$interopDefault($01dd1839b5376a46$exports), 'flex-container', styleProps.className),
      ref: domRef
    }), /*#__PURE__*/$9LQqs$react.createElement("div", {
      className: $9LQqs$classNames( /*@__PURE__*/$parcel$interopDefault($01dd1839b5376a46$exports), 'flex', 'flex-gap'),
      style: _style
    }, children));
  } // If no gaps, or native support exists, then we only need to render a single div.


  var style = _objectSpread(_objectSpread({}, styleProps.style), flexStyle.style);

  if (props.gap != null) style.gap = $9LQqs$responsiveDimensionValue(props.gap, matchedBreakpoints);
  if (props.columnGap != null) style.columnGap = $9LQqs$responsiveDimensionValue(props.columnGap, matchedBreakpoints);
  if (props.rowGap != null) style.rowGap = $9LQqs$responsiveDimensionValue(props.rowGap, matchedBreakpoints);
  return /*#__PURE__*/$9LQqs$react.createElement("div", _objectSpread(_objectSpread({}, $9LQqs$filterDOMProps(otherProps)), {}, {
    className: $9LQqs$classNames( /*@__PURE__*/$parcel$interopDefault($01dd1839b5376a46$exports), 'flex', styleProps.className),
    style: style,
    ref: domRef
  }), children);
}
/**
 * Normalize 'start' and 'end' alignment values to 'flex-start' and 'flex-end'
 * in flex containers for browser compatibility.
 */


function $884c64d19340d345$var$flexAlignValue(value) {
  if (value === 'start') return 'flex-start';
  if (value === 'end') return 'flex-end';
  return value;
}
/**
 * Takes a boolean and translates it to flex wrap or nowrap.
 */


function $884c64d19340d345$var$flexWrapValue(value) {
  if (typeof value === 'boolean') return value ? 'wrap' : 'nowrap';
  return value;
} // Original licensing for the following method can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/Modernizr/Modernizr/blob/7efb9d0edd66815fb115fdce95fabaf019ce8db5/feature-detects/css/flexgap.js


var $884c64d19340d345$var$_isFlexGapSupported = null;

function $884c64d19340d345$var$isFlexGapSupported() {
  if ($884c64d19340d345$var$_isFlexGapSupported != null) return $884c64d19340d345$var$_isFlexGapSupported;
  if (typeof document === 'undefined') return false; // create flex container with row-gap set

  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  $884c64d19340d345$var$_isFlexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  flex.parentNode.removeChild(flex);
  return $884c64d19340d345$var$_isFlexGapSupported;
}
/**
 * A layout container using flexbox. Provides Spectrum dimension values, and supports the gap
 * property to define consistent spacing between items.
 */


var $884c64d19340d345$export$f51f4c4ede09e011 = /*#__PURE__*/$9LQqs$forwardRef($884c64d19340d345$var$Flex);
export { $994c48bfb00b620b$export$76d90c956114f2c2 as repeat, $994c48bfb00b620b$export$9c1b655deaca4988 as minmax, $994c48bfb00b620b$export$2f0b47b0911ce698 as fitContent, $994c48bfb00b620b$export$ef2184bd89960b14 as Grid, $884c64d19340d345$export$f51f4c4ede09e011 as Flex };